import { render, staticRenderFns } from "./create-client.vue?vue&type=template&id=0d9fd7a0&"
import script from "./create-client.vue?vue&type=script&lang=js&"
export * from "./create-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports